import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`The Category Object`}</h2>
    <p>{`The category Object contains category data with links to Subcategory Object and featured Gif Object`}</p>
    <div className="props-table">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Property`}</th>
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Example`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`name:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`Category name`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"category 1"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`name_encoded:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`Encoded category name`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"category1"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`subcategories:`}</strong>{` `}<a href="/docs/api/schema#sub-category-object">{`Subcategory Object`}</a><br />{`List of subcategories`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`gif:`}</strong>{` `}<a href="/docs/api/schema#gif-object">{`Gif Object`}</a><br />{`Featured gif for category.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}></td>
          </tr>
        </tbody>
      </table>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      